// extracted by mini-css-extract-plugin
export default {"mainLoading":"MainLoading_mainLoading__rdRgV"};